<template>
  <div class="Wave">
    <div v-if="releasingWave">
      <Spinner message="Releasing wave... Please wait" />
    </div>
    <div v-else-if="error">
      <h4>We're sorry, an unexpected error occurred</h4>
      <p>{{ error.message }}</p>
      <btn @click="error = null">Try again</btn>
    </div>
    <div v-else>
      <OrderTable
        v-model="selection"
        :orders="orders"
        :cols="[
          'Zone',
          'Account',
          'Type',
          'Order Notes',
          'Delivery Notes',
          'Address',
          'Qty',
          'Invoices',
          'Status',
        ]"
        tab="wave"
      >
        <span v-if="wave.releasedAt === null">
          <btn
            ref="downloadPicklabel"
            type="primary"
            data-popover-trigger
            @click="togglePopover('downloadPicklabel')"
          >
            {{ downloadPicklabel.buttonText }}
          </btn>
          <popover
            :target="$refs.downloadPicklabel"
            v-model="downloadPicklabel.showPopover"
            trigger="manual"
            placement="bottom"
          >
            <template slot="popover">
              <div style="margin: 10px 10px 0px 10px">
                <label>What kind of label?</label>
                <select v-model="downloadPicklabel.template">
                  <option value="sortedByLocation">Sorted by location</option>
                  <option value="sortedByOrder">Sorted by order</option>
                </select>
              </div>
              <div style="margin: 10px">
                <btn
                  type="primary"
                  :disabled="downloadPicklabel.requesting"
                  @click="handleRequestPicklabel"
                >
                  Request
                </btn>
                <btn @click="downloadPicklabel.showPopover = false">Close</btn>
              </div>
              <div
                v-if="downloadPicklabel.jobLinkText"
                style="margin: 0 10px 10px 10px"
              >
                <a
                  v-if="downloadPicklabel.jobLink"
                  :href="downloadPicklabel.jobLink"
                  target="_blank"
                  rel="noopener"
                  >{{ downloadPicklabel.jobLinkText }}</a
                >
                <span v-else>{{ downloadPicklabel.jobLinkText }}</span>
              </div>
            </template>
          </popover>
          <btn @click="handleReleaseWaveClick" type="primary"
            >Release Wave
          </btn>
        </span>
        <span v-else>
          <btn
            ref="downloadPicklabel"
            type="primary"
            data-popover-trigger
            @click="togglePopover('downloadPicklabel')"
          >
            {{ downloadPicklabel.buttonText }}
          </btn>
          <popover
            :target="$refs.downloadPicklabel"
            v-model="downloadPicklabel.showPopover"
            trigger="manual"
            placement="bottom"
          >
            <template slot="popover">
              <div style="margin: 10px 10px 0px 10px">
                <label>What kind of label?</label>
                <select v-model="downloadPicklabel.template">
                  <option value="sortedByLocation">Sorted by location</option>
                  <option value="sortedByOrder">Sorted by order</option>
                </select>
              </div>
              <div style="margin: 10px">
                <btn
                  type="primary"
                  :disabled="downloadPicklabel.requesting"
                  @click="handleRequestPicklabel"
                >
                  Request
                </btn>
                <btn @click="downloadPicklabel.showPopover = false">Close</btn>
              </div>
              <div
                v-if="downloadPicklabel.jobLinkText"
                style="margin: 0 10px 10px 10px"
              >
                <a
                  v-if="downloadPicklabel.jobLink"
                  :href="downloadPicklabel.jobLink"
                  target="_blank"
                  rel="noopener"
                  >{{ downloadPicklabel.jobLinkText }}</a
                >
                <span v-else>{{ downloadPicklabel.jobLinkText }}</span>
              </div>
            </template>
          </popover>
          <btn
            ref="downloadPicksheet"
            type="primary"
            data-popover-trigger
            @click="togglePopover('downloadPicksheet')"
          >
            {{ downloadPicksheet.buttonText }}
          </btn>
          <popover
            :target="$refs.downloadPicksheet"
            v-model="downloadPicksheet.showPopover"
            trigger="manual"
            placement="bottom"
          >
            <template slot="popover">
              <div style="margin: 10px 10px 0px 10px">
                <label>What kind of picksheet?</label>
                <select v-model="downloadPicksheet.template">
                  <option value="sortedByLocation">Sorted by location</option>
                  <option value="sortedByOrder">Sorted by order</option>
                </select>
              </div>
              <div style="margin: 10px">
                <btn
                  type="primary"
                  :disabled="downloadPicksheet.requesting"
                  @click="handleRequestPicksheet"
                >
                  Request
                </btn>
                <btn @click="downloadPicksheet.showPopover = false">Close</btn>
              </div>
              <div
                v-if="downloadPicksheet.jobLinkText"
                style="margin: 0 10px 10px 10px"
              >
                <a
                  v-if="downloadPicksheet.jobLink"
                  :href="downloadPicksheet.jobLink"
                  target="_blank"
                  rel="noopener"
                  >{{ downloadPicksheet.jobLinkText }}</a
                >
                <span v-else>{{ downloadPicksheet.jobLinkText }}</span>
              </div>
            </template>
          </popover>
          <btn
            ref="requestBOLBundle"
            type="primary"
            data-popover-trigger
            @click="togglePopover('requestBOLBundle')"
          >
            BOL Bundle
          </btn>
          <popover
            :target="$refs.requestBOLBundle"
            v-model="requestBOLBundle.showPopover"
            trigger="manual"
            placement="bottom"
          >
            <template slot="popover">
              <form @submit.prevent="handleRequestBOLBundleClick">
                <div style="margin: 10px 10px 0px 10px">
                  <label>Include invoices?</label>
                  <input
                    type="checkbox"
                    v-model="requestBOLBundle.formIncludeInvoices"
                  />
                </div>
                <div style="margin: 10px 10px 0px 10px">
                  <label>Split bundle into multiple files?</label>
                  <input
                    type="checkbox"
                    v-model="requestBOLBundle.formShouldZip"
                  />
                </div>
                <div style="margin: 10px">
                  <btn
                    type="primary"
                    native-type="submit"
                    :disabled="requestBOLBundle.requesting"
                  >
                    Request
                  </btn>
                  <btn @click="requestBOLBundle.showPopover = false"
                    >Close</btn
                  >
                </div>
                <div
                  v-if="requestBOLBundle.jobLinkText"
                  style="margin: 0 10px 10px 10px"
                >
                  <a
                    v-if="requestBOLBundle.jobLink"
                    :href="requestBOLBundle.jobLink"
                    target="_blank"
                    rel="noopener"
                    >{{ requestBOLBundle.jobLinkText }}</a
                  >
                  <span v-else>{{ requestBOLBundle.jobLinkText }}</span>
                </div>
              </form>
            </template>
          </popover>
        </span>
      </OrderTable>
      <OrderSelection v-model="selection">
        <template slot-scope="{ doAction }">
          <span v-if="wave.releasedAt === null">
            <btn @click="doAction('Removing', removeFromWave)" type="danger">
              Remove from Wave
            </btn>
          </span>
          <span v-else-if="allowSendToDispatchTrack">
            <btn
              @click="
                doAction('Sending to Dispatch Track', sendToDispatchTrack)
              "
              type="primary"
            >
              Send to Dispatch Track
            </btn>
          </span>
        </template>
      </OrderSelection>
    </div>
  </div>
</template>

<script>
import {
  getOrders,
  removeOrdersFromWave,
  releaseWave,
  sendOrdersToDispatchTrack,
} from '@/queries';
import { requestBOLBundle, requestReport, jobsUrl, jobUrl } from '@/api';

import { formatGraphQLError } from '@/utils';
import singleOpenPopovers from '@/mixins/singleOpenPopovers';

export default {
  name: 'Waves',
  props: ['wave', 'orders', 'pickDate', 'allowSendToDispatchTrack'],
  data() {
    return {
      selection: [],
      error: null,
      releasingWave: false,
      requestBOLBundle: {
        showPopover: false,
        formIncludeInvoices: true,
        formShouldZip: false,
        requesting: false,
        jobLink: null,
        jobLinkText: null,
      },
      downloadPicksheet: {
        showPopover: false,
        buttonText: 'Picksheet',
        buttonClass: ['btn', 'btn-primary'],
        template: 'sortedByLocation',
        requesting: false,
        jobLink: null,
        jobLinkText: null,
      },
      downloadPicklabel: {
        showPopover: false,
        buttonText: 'Picklabel',
        buttonClass: ['btn', 'btn-primary'],
        template: 'sortedByLocation',
        requesting: false,
        jobLink: null,
        jobLinkText: null,
      },
    };
  },
  watch: {
    // A prior request's job link refers to the template as submitted — clear
    // it when the selection changes (mirrors Routing.vue).
    'downloadPicklabel.template'() {
      this.downloadPicklabel.jobLink = null;
      this.downloadPicklabel.jobLinkText = null;
    },
    'downloadPicksheet.template'() {
      this.downloadPicksheet.jobLink = null;
      this.downloadPicksheet.jobLinkText = null;
    },
    'requestBOLBundle.formIncludeInvoices'() {
      this.requestBOLBundle.jobLink = null;
      this.requestBOLBundle.jobLinkText = null;
    },
    'requestBOLBundle.formShouldZip'() {
      this.requestBOLBundle.jobLink = null;
      this.requestBOLBundle.jobLinkText = null;
    },
  },
  mixins: [singleOpenPopovers(['downloadPicklabel', 'downloadPicksheet', 'requestBOLBundle'])],
  methods: {
    // Shared: request a report on wineapp's job system and reflect the
    // outcome on the popover's state (mirrors Routing.vue).
    async requestReportJob(state, params) {
      state.requesting = true;
      state.jobLink = null;
      state.jobLinkText = null;
      try {
        const res = await requestReport(params);
        if (res.existing) {
          state.jobLink = jobUrl(res.job_receipt_id);
          state.jobLinkText = 'Job In Progress';
        } else {
          state.jobLink = jobsUrl();
          state.jobLinkText = 'Requested — view in Jobs';
        }
      } catch (e) {
        state.jobLink = null;
        state.jobLinkText = 'Request failed — try again.';
      } finally {
        state.requesting = false;
      }
    },
    async handleRequestPicklabel() {
      await this.requestReportJob(this.downloadPicklabel, {
        report: 'picklabel',
        template: this.downloadPicklabel.template,
        waveId: this.wave.id,
        pickDate: this.pickDate,
      });
    },
    async handleRequestPicksheet() {
      await this.requestReportJob(this.downloadPicksheet, {
        report: 'picksheet',
        template: this.downloadPicksheet.template,
        waveId: this.wave.id,
        pickDate: this.pickDate,
      });
    },
    async handleRequestBOLBundleClick() {
      const state = this.requestBOLBundle;
      if (state.requesting) {
        return;
      }
      state.requesting = true;
      state.jobLink = null;
      state.jobLinkText = null;

      try {
      const filename = [
        'bol-bundle',
        this.requestBOLBundle.formIncludeInvoices
          ? 'with-invoices'
          : 'without-invoices',
        `wave-${this.wave.name}`,
        this.pickDate,
      ].join('-');

      const email_subject = [
        'BOL Bundle',
        this.requestBOLBundle.formIncludeInvoices
          ? 'with invoices'
          : 'without invoices',
        `for wave ${this.wave.name}`,
        `on ${this.pickDate}`,
      ].join(' ');

      const { success, existing, jobReceiptId } = await requestBOLBundle({
        filename: filename,
        email_subject,
        pick_date: this.pickDate,
        order_ids: this.orders.map((order) => order.skId).join(','),
        include_invoices: state.formIncludeInvoices,
        should_zip: state.formShouldZip,
      });

      // Same jobLink structure as the report popovers (Routing parity): the
      // popover stays open showing where the job went.
      if (!success) {
        state.jobLinkText = 'Request failed — try again.';
      } else if (existing) {
        state.jobLink = jobUrl(jobReceiptId);
        state.jobLinkText = 'Job In Progress';
      } else {
        state.jobLink = jobsUrl();
        state.jobLinkText = 'Requested — view in Jobs';
      }
      } catch (e) {
        state.jobLink = null;
        state.jobLinkText = 'Request failed — try again.';
      } finally {
        state.requesting = false;
      }
    },
    async handleReleaseWaveClick() {
      if (
        !confirm(
          `Are you sure you want to release wave "${this.wave.name}" for picking? This action cannot be undone`
        )
      ) {
        return;
      }

      this.releasingWave = true;

      try {
        await this.$apollo.mutate({
          mutation: releaseWave,
          variables: {
            input: {
              id: this.wave.id,
            },
          },
        });
      } catch (e) {
        // Assign to local state since there's no OrderSelection
        this.error = formatGraphQLError(e);
      }

      this.releasingWave = false;
    },

    async removeFromWave(orders) {
      try {
        return this.$apollo.mutate({
          mutation: removeOrdersFromWave,
          variables: {
            input: {
              waveId: this.wave.id,
              orderIds: orders.map((order) => order.id),
            },
          },
        });
      } catch (e) {
        // Throw to delegate back to OrderSelection catch block
        throw formatGraphQLError(e);
      }
    },
    async sendToDispatchTrack(orders) {
      try {
        return this.$apollo.mutate({
          mutation: sendOrdersToDispatchTrack,
          variables: {
            input: {
              ids: orders.map((order) => order.id),
            },
          },
        });
      } catch (e) {
        console.log('caught an error');
        // Throw to delegate back to OrderSelection catch block
        throw formatGraphQLError(e);
      }
    },
    tab() {
      return 'waves';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Wave.vue